import { STATUSES } from 'constants/constants';

export default function getPreparationOrderStatusText(status = '') {
  return STATUSES[status]?.text || status;
}
